import { render } from "./ReportCard.vue?vue&type=template&id=5e689c28&scoped=true"
import script from "./ReportCard.vue?vue&type=script&lang=js"
export * from "./ReportCard.vue?vue&type=script&lang=js"

import "./ReportCard.vue?vue&type=style&index=0&id=5e689c28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e689c28"]])

export default __exports__